// Leveringsstepper - EuropeSnus (design G)
// ----------------------------------------
// Tre trin paa een raekke. Timeren er undertekst paa trin 2, ikke et eget baand.
// Leveringstider kommer fra Shopifys fragtprofiler (TRANSIT nedenfor).
// Geolokation via window.ESGeo (snippets/geo-country.liquid) - kun som rettelse
// oven paa Liquids markedsland, saa foerste render aldrig er tom.

(function () {

  // CONFIG
  var DEFAULT_CUTOFF_HOUR = 14;
  var MIN_TRANSIT = 2;
  var SHOP_TZ = 'Europe/Copenhagen';

  // Danske helligdage (YYYY-MM-DD) - PostNord henter ikke.
  // Kan udvides uden kodeaendring via Temaindstillinger > Kurv > Lukkedage,
  // som lander i data-holidays paa elementet.
  var HOLIDAYS = [
    '2025-01-01','2025-04-17','2025-04-18','2025-04-20','2025-04-21',
    '2025-05-16','2025-05-29','2025-06-05','2025-06-06','2025-12-25','2025-12-26',
    '2026-01-01','2026-04-02','2026-04-03','2026-04-05','2026-04-06',
    '2026-05-01','2026-05-14','2026-05-25','2026-06-05','2026-12-25','2026-12-26',
    '2027-01-01','2027-03-25','2027-03-26','2027-03-28','2027-03-29',
    '2027-05-06','2027-05-17','2027-06-04','2027-06-05','2027-12-24','2027-12-25','2027-12-26'
  ];

  var TRANSIT = {
    AL: [2, 4],  AT: [2, 3],  AD: [4, 7],  BE: [2, 2],  BA: [5, 10],
    BG: [4, 5],  CA: [3, 7],  HR: [4, 6],  CY: [3, 5],  CZ: [2, 3],
    DK: [2, 2],  EE: [4, 5],  FO: [2, 3],  FI: [2, 4],  FR: [2, 3],
    DE: [2, 2],  GR: [4, 7],  GL: [3, 5],  HU: [3, 5],  IS: [3, 4],
    IE: [3, 5],  IT: [3, 4],  LV: [4, 5],  LI: [3, 4],  LT: [4, 5],
    LU: [2, 3],  MT: [3, 5],  MC: [3, 4],  NL: [2, 2],  NO: [3, 5],
    PL: [4, 6],  PT: [4, 5],  RO: [3, 3],  SM: [4, 7],  RS: [3, 5],
    SK: [3, 3],  SI: [3, 4],  ES: [3, 5],  SE: [2, 4],  CH: [2, 4],
    GB: [2, 5],  US: [3, 7],
    DEFAULT: [3, 5]
  };

  // --- oversaettelser -------------------------------------------------
  var FALLBACK = {
    edd_ordered: 'Ordered',
    edd_delivered: 'Delivered',
    edd_today: 'Today',
    edd_ships_today: 'Ships today',
    edd_ships_tomorrow: 'Ships tomorrow',
    edd_ships_on: 'Ships {{ day }}',
    edd_order_within_short: 'Order within {{ time }}',
    edd_order_by: 'Order by {{ time }}',
    edd_arrives: 'arrives {{ date }}',
    edd_h: 'h',
    edd_m: 'm'
  };

  function t(key, vars) {
    var s;
    try { s = window.KROWN.settings.locales[key]; } catch (e) { s = null; }
    if (!s) s = FALLBACK[key] || key;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), vars[k]);
      });
    }
    return s;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // --- kalender -------------------------------------------------------
  function ymd(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }
  function isHoliday(d, extra) {
    var key = ymd(d);
    return HOLIDAYS.indexOf(key) !== -1 || (extra && extra.indexOf(key) !== -1);
  }
  function isWorkday(d, extra) {
    var day = d.getDay();
    return day !== 0 && day !== 6 && !isHoliday(d, extra);
  }
  function addWorkdays(d, n, extra) {
    var r = new Date(d), added = 0;
    while (added < n) { r.setDate(r.getDate() + 1); if (isWorkday(r, extra)) added++; }
    return r;
  }
  function nextWorkday(d, extra) {
    var r = new Date(d); r.setDate(r.getDate() + 1);
    while (!isWorkday(r, extra)) r.setDate(r.getDate() + 1);
    return r;
  }

  // --- datoformat -----------------------------------------------------
  // Foelger sidens sprog (<html lang>). Korte maanedsnavne uden punktum.
  var _dtfDay = null, _lang = null;
  function lang() {
    if (!_lang) _lang = document.documentElement.lang || 'en-GB';
    return _lang;
  }
  function dayMonthFormat() {
    if (_dtfDay) return _dtfDay;
    try { _dtfDay = new Intl.DateTimeFormat(lang(), { day: 'numeric', month: 'short' }); }
    catch (e) { _dtfDay = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' }); }
    return _dtfDay;
  }
  function stripDots(s) { return s.replace(/\.(?=\s|$)/g, '').trim(); }

  function fmtDayMonth(d) {
    var f = dayMonthFormat(), parts = f.formatToParts(d);
    var alphabetic = parts.some(function (p) { return p.type === 'month' && /[^\d\s.]/.test(p.value); });
    if (!alphabetic) return f.format(d); // fi: "28.10." - punktummet er en del af formatet
    return stripDots(parts.map(function (p) {
      return p.type === 'literal' ? p.value.replace(/\./g, '') : p.value.replace(/\.$/, '');
    }).join(''));
  }
  function fmtWeekday(d, long) {
    try {
      return stripDots(new Intl.DateTimeFormat(lang(), { weekday: long ? 'long' : 'short' }).format(d));
    } catch (e) { return ''; }
  }
  // "Tue 28 - Thu 30 Oct". Ugedagen er det, der gor datoen konkret.
  function fmtDeliveryRange(min, max) {
    var endLabel = fmtWeekday(max) + ' ' + fmtDayMonth(max);
    if (min.getTime() === max.getTime()) return endLabel;
    var sameMonth = min.getMonth() === max.getMonth() && min.getFullYear() === max.getFullYear();
    var parts = dayMonthFormat().formatToParts(max);
    var dayFirst = parts.length && parts[0].type === 'day';
    var startLabel = (sameMonth && dayFirst)
      ? fmtWeekday(min) + ' ' + min.getDate()
      : fmtWeekday(min) + ' ' + fmtDayMonth(min);
    return startLabel + ' – ' + endLabel;
  }
  // Timer og minutter, aldrig sekunder. Sekunder opleves som manipulation.
  function fmtHM(secs) {
    var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60);
    if (h > 0) return h + t('edd_h') + ' ' + String(m).padStart(2, '0') + t('edd_m');
    return m + t('edd_m');
  }
  function fmtClock(hour) { return String(hour).padStart(2, '0') + ':00'; }

  // --- butikkens lokaltid ---------------------------------------------
  // Serverens UTC-tidsstempel + den tid der er gaaet siden page load.
  var _serverEpochMs = null, _perfBase = null;
  function nowMs() {
    if (_serverEpochMs === null) return Date.now();
    return _serverEpochMs + (Date.now() - _perfBase);
  }
  function shopNow() {
    var n = new Date(nowMs());
    // Samme vaegurstid som i Europe/Copenhagen, uanset kundens egen tidszone.
    return new Date(n.toLocaleString('en-US', { timeZone: SHOP_TZ }));
  }

  function calcDates(transit, cutoffHour, extraHolidays) {
    var dnNow = shopNow();
    var today = new Date(dnNow); today.setHours(0, 0, 0, 0);
    var todayIsWorkday = isWorkday(dnNow, extraHolidays);
    var beforeCutoff = dnNow.getHours() < cutoffHour && todayIsWorkday;
    var ships = beforeCutoff ? new Date(today) : nextWorkday(today, extraHolidays);
    var deliverMin = addWorkdays(ships, Math.max(transit[0], MIN_TRANSIT), extraHolidays);
    var deliverMax = addWorkdays(ships, Math.max(transit[1], MIN_TRANSIT), extraHolidays);

    var secsLeft = null;
    if (beforeCutoff) {
      var cutoffToday = new Date(dnNow); cutoffToday.setHours(cutoffHour, 0, 0, 0);
      secsLeft = Math.max(0, Math.floor((cutoffToday - dnNow) / 1000));
    }

    var tomorrow = new Date(today); tomorrow.setDate(tomorrow.getDate() + 1);
    var shipsToday = ships.getTime() === today.getTime();
    var shipsTomorrow = ships.getTime() === tomorrow.getTime();

    return {
      today: today, ships: ships, deliverMin: deliverMin, deliverMax: deliverMax,
      secsLeft: secsLeft, shipsToday: shipsToday, shipsTomorrow: shipsTomorrow
    };
  }

  // --- render ---------------------------------------------------------
  function stepTwo(res, cutoffHour) {
    if (res.shipsToday) {
      return {
        label: t('edd_ships_today'),
        sub: t('edd_order_within_short', { time: fmtHM(res.secsLeft) }),
        urgent: true,
        live: true
      };
    }
    if (res.shipsTomorrow) {
      // Timeren forsvinder ikke efter deadline - den peger paa naeste pakkedag.
      return { label: t('edd_ships_tomorrow'), sub: t('edd_order_by', { time: fmtClock(cutoffHour) }), urgent: false, live: false };
    }
    return { label: t('edd_ships_on', { day: fmtWeekday(res.ships, true) }), sub: '', urgent: false, live: false };
  }

  function colHTML(opts) {
    return '<div class="edd-col' + (opts.done ? ' edd-col--done' : '') + '">'
      + '<div class="edd-track">' + opts.track + '</div>'
      + '<span class="edd-label">' + esc(opts.label) + '</span>'
      + (opts.sub
        ? '<span class="edd-sub' + (opts.urgent ? ' edd-sub--urgent' : '') + '"'
          + (opts.live ? ' id="edd-timer" aria-live="off"' : '') + '>' + esc(opts.sub) + '</span>'
        : '')
      + '</div>';
  }

  function render(el) {
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    if (!Number.isFinite(cutoffHour)) cutoffHour = DEFAULT_CUTOFF_HOUR;
    var extraHolidays = (el.dataset.holidays || '').split(/[,\s]+/).filter(Boolean);
    var transit = TRANSIT[el.dataset.country] || TRANSIT.DEFAULT;
    var res = calcDates(transit, cutoffHour, extraHolidays);
    var two = stepTwo(res, cutoffHour);
    var range = fmtDeliveryRange(res.deliverMin, res.deliverMax);

    el.innerHTML = '<div class="edd-row">'
      + colHTML({ done: true, label: t('edd_ordered'), sub: t('edd_today'), track: '<span class="edd-dot"></span><span class="edd-bar edd-bar--done"></span>' })
      + colHTML({ done: true, label: two.label, sub: two.sub, urgent: two.urgent, live: two.live, track: '<span class="edd-bar edd-bar--done"></span><span class="edd-dot"></span><span class="edd-bar"></span>' })
      + colHTML({ done: false, label: t('edd_delivered'), sub: range, track: '<span class="edd-bar"></span><span class="edd-dot"></span>' })
      + '</div>';

    el._state = { res: res, cutoffHour: cutoffHour, range: range };
    syncFooter(el);
    scheduleTick(el);
  }

  // Footeren gentager deadline + leveringsdato paa een linje.
  function syncFooter(el) {
    var s = el._state;
    if (!s) return;
    var line = s.res.shipsToday
      ? t('edd_order_by', { time: fmtClock(s.cutoffHour) }) + ' · ' + t('edd_arrives', { date: s.range })
      : t('edd_arrives', { date: s.range });
    line = line.charAt(0).toUpperCase() + line.slice(1);
    document.querySelectorAll('[data-cart-eta]').forEach(function (node) {
      node.textContent = line;
    });
  }

  // Et minut ad gangen - teksten viser alligevel kun hele minutter.
  var _tick = null;
  function scheduleTick(el) {
    if (_tick) { clearInterval(_tick); _tick = null; }
    var s = el._state;
    if (!s || s.res.secsLeft === null) return;
    _tick = setInterval(function () {
      var fresh = calcDates(TRANSIT[el.dataset.country] || TRANSIT.DEFAULT, s.cutoffHour,
        (el.dataset.holidays || '').split(/[,\s]+/).filter(Boolean));
      if (fresh.secsLeft === null || !fresh.shipsToday) {
        clearInterval(_tick); _tick = null;
        render(el); // deadline passeret -> naeste pakkedag, datoen rykker med
        return;
      }
      var node = el.querySelector('#edd-timer');
      if (node) node.textContent = t('edd_order_within_short', { time: fmtHM(fresh.secsLeft) });
      s.res.secsLeft = fresh.secsLeft;
    }, 60000);
  }

  if (!customElements.get('estimated-delivery')) {
    customElements.define('estimated-delivery', class extends HTMLElement {
      connectedCallback() {
        var self = this;

        if (_serverEpochMs === null) {
          var srv = parseInt(self.dataset.now, 10);
          if (Number.isFinite(srv) && srv > 0) {
            _serverEpochMs = srv * 1000;
            _perfBase = Date.now();
          }
        }
        if (!self.dataset.country) self.dataset.country = 'DEFAULT';

        // Synkron foerste render med markedets land fra Liquid: ingen tom timer,
        // intet "Loading..."-glimt.
        render(self);

        // ESGeo retter bagefter, hvis geo-landet afviger fra markedet.
        if (window.ESGeo && typeof window.ESGeo.get === 'function') {
          window.ESGeo.get(function (cc) {
            if (cc && cc !== self.dataset.country && TRANSIT[cc]) {
              self.dataset.country = cc;
              render(self);
            }
          });
        }

        document.addEventListener('cart:updated', function () { render(self); });
        document.addEventListener('DOMContentLoaded', function () { syncFooter(self); });
      }

      disconnectedCallback() {
        if (_tick) { clearInterval(_tick); _tick = null; }
      }
    });
  }

})();
